import React from 'react';
import { FormCheck } from 'react-bootstrap';
import { connect } from 'react-redux';
import { consultantHealthInsurerSingleUpdate } from '../../lib/redux/actions/consultantHealthInsurer';
import PropTypes from 'prop-types';
import { Cell } from 'react-sticky-table';
import { isSeniorStaff } from '../../lib/helper/authorisation';
import { niceDateFormatter } from '../../lib/helper/formatting';
import moment from 'moment';

const mapDispatchToProps = {
  consultantHealthInsurerSingleUpdate,
};

class EditableToggleCell extends React.Component {
  constructor(props) {
    super(props);
    const dateField = props.dateFieldName || props.fieldName;
    this.state = {
      fieldValue: Boolean(props.consultantHealthInsurer[props.fieldName]),
      changeDate: props.consultantHealthInsurer[dateField] || null,
      recordedBy: props.recordedByFieldName ? props.consultantHealthInsurer[props.recordedByFieldName] || null : null,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { fieldName, dateFieldName } = this.props;
    const dateField = dateFieldName || fieldName;
    if (
      prevProps.consultantHealthInsurer &&
      this.props.consultantHealthInsurer &&
      prevProps.consultantHealthInsurer[fieldName] !== this.props.consultantHealthInsurer[fieldName]
    ) {
      this.setState(() => ({
        fieldValue: Boolean(this.props.consultantHealthInsurer[fieldName]),
        changeDate: this.props.consultantHealthInsurer[dateField] || null,
        recordedBy: this.props.recordedByFieldName ? this.props.consultantHealthInsurer[this.props.recordedByFieldName] || null : null,
      }));
    }
  }

  handleChange(event) {
    const { reloadCodes, fieldName, useDateValue, dateFieldName, recordedByFieldName, onAfterUpdate } = this.props;
    const newValue = useDateValue ? (event.target.checked ? moment() : null) : event.target.checked;

    if (!isSeniorStaff()) {
      return;
    }

    this.props
      .consultantHealthInsurerSingleUpdate({ [fieldName]: newValue }, this.props.consultantHealthInsurer.id)
      .then((response) => {
        const dateField = dateFieldName || fieldName;
        this.setState(() => ({
          fieldValue: Boolean(newValue),
          changeDate: response[dateField] || newValue || null,
          recordedBy: recordedByFieldName ? response[recordedByFieldName] || null : null,
        }));
        if (onAfterUpdate) {
          onAfterUpdate();
        }
      })
      .then(() => {
        reloadCodes();
      });
  }

  buildTitle() {
    const { consultantHealthInsurer, consultantCreatedDate, label } = this.props;
    const { healthInsurer } = consultantHealthInsurer;
    const { changeDate, recordedBy } = this.state;

    if (!this.state.fieldValue) {
      return '';
    }

    const dateStr = changeDate ? niceDateFormatter(changeDate) : niceDateFormatter(consultantCreatedDate) + ' (Consultant created)';

    const actionedBy = changeDate && recordedBy ? ` Actioned By: ${recordedBy.firstName} ${recordedBy.lastName}` : '';

    return `${healthInsurer.name}: ${label} since ${dateStr}${actionedBy}`;
  }

  render() {
    const { consultantHealthInsurer, idPrefix, disabledWhenChecked } = this.props;
    const title = this.buildTitle();

    return (
      <Cell className="text-center border-right" title={title}>
        <FormCheck
          type="switch"
          onChange={this.handleChange}
          id={`${idPrefix}-${consultantHealthInsurer.id}`}
          checked={this.state.fieldValue}
          disabled={!isSeniorStaff() || (disabledWhenChecked && this.state.fieldValue)}
          title={title}
        />
      </Cell>
    );
  }
}

EditableToggleCell.propTypes = {
  consultantHealthInsurer: PropTypes.object.isRequired,
  consultantCreatedDate: PropTypes.string.isRequired,
  reloadCodes: PropTypes.func.isRequired,
  consultantHealthInsurerSingleUpdate: PropTypes.func.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  idPrefix: PropTypes.string.isRequired,
  useDateValue: PropTypes.bool,
  disabledWhenChecked: PropTypes.bool,
  dateFieldName: PropTypes.string,
  recordedByFieldName: PropTypes.string,
  onAfterUpdate: PropTypes.func,
};

EditableToggleCell.defaultProps = {
  useDateValue: false,
  disabledWhenChecked: false,
  dateFieldName: null,
  recordedByFieldName: null,
  onAfterUpdate: null,
};

export default connect(null, mapDispatchToProps)(EditableToggleCell);
